import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { teamUpdateTeamMemberStatus } from "backend/api/team.service";
import { MessageType } from "backend/model/messageType";
import { TeamMemberStatus } from "backend/model/teamMemberStatus";
import { USER_MEMBER_FIRM_ID_KEY } from "src/app/classic/classic-interceptor";

export const PROBLEM_DETECTED = $localize`Problem detected`;
export const CROSSBORDER_BLOCKLIST_WARNING = $localize`Access to this engagement is currently restricted. Speak to the Group audit engagement partner for more information.`;
export const REMOVED_WORKSPACE_WARNING = $localize`Restore this workspace before trying again to open it`;
/** Used when user is attempting to perform an action on a remote storage engagement */
export const STALE_REMOTE_STORAGE_WARNING = $localize`Unable to perform this action as engagement has been moved to remote storage.`;

@Injectable({
  providedIn: "root",
})
export class WorkspaceListNavigationService {
  private readonly httpClient = inject(HttpClient);

  lastEngagementIdNavigatedTo: string | undefined;

  async updateTeamMemberStatus(
    engagementId: string,
    status: TeamMemberStatus,
    hostMemberFirmId: number,
    isClassic?: boolean,
  ): Promise<string | undefined> {
    sessionStorage.setItem(USER_MEMBER_FIRM_ID_KEY, `${hostMemberFirmId}`);

    try {
      const result = await teamUpdateTeamMemberStatus(this.httpClient, {
        request: {
          engagementId,
          status,
          hostMemberFirmId,
          canModifyEngagementAfterArchive: true,
          canAllowGuestRole: true,
          isClassic,
        },
      });
      const failureMessage = result?.messages.find(
        (x) => x.messageType === MessageType.Error,
      );
      if (failureMessage) {
        return failureMessage.code;
      } else {
        return undefined;
      }
    } catch (error: unknown) {
      return "UnknownError";
    }
  }
}
